// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationMenuItem } from "../../../components/ApplicationMenu";
import { ApplicationWindow } from "../../../components/ApplicationWindow";
import { FavoriteAction, OpenAction } from "./MenuAction";
import { FavoriteService } from "../../Favorite";
import { FeatureDataPrefetch } from "../../Feature/components/FeatureDataPrefetch";
import { isUrl } from "../../../utils/path";
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuItem = props => {
  const {
    name,
    adresse,
    exact,
    libelle,
    icone,
    module,
    offset
  } = props;
  if (isUrl(adresse)) {
    return /*#__PURE__*/_jsx(ApplicationMenuItem, {
      name: `menu.${name}`,
      content: libelle,
      path: adresse,
      icon: icone || "empty set",
      offset: offset,
      direction: "row",
      target: "_blank",
      popup: true,
      link: true
    });
  }
  return /*#__PURE__*/_jsx(ApplicationWindow, {
    path: adresse,
    "data-sentry-element": "ApplicationWindow",
    "data-sentry-component": "MenuItem",
    "data-sentry-source-file": "MenuItem.tsx",
    children: ({
      onOpen
    }) => /*#__PURE__*/_jsx(FeatureDataPrefetch, {
      path: adresse,
      children: /*#__PURE__*/_jsx(ApplicationMenuItem, {
        name: name,
        content: libelle,
        actions: [/*#__PURE__*/_jsx(OpenAction, {
          onClick: onOpen
        }, "open"), !FavoriteService.existFavorite(name, module) && /*#__PURE__*/_jsx(FavoriteAction, {
          favorite: {
            code: name,
            libelle,
            adresse,
            module
          }
        }, "favorite")].filter(Boolean),
        path: adresse || "",
        exact: exact,
        icon: icone || "",
        offset: offset,
        direction: "row",
        popup: true,
        link: true
      })
    })
  });
};